import ClinicalNotesScreen from "../../components/ipd/clinicalNotes/ClinicalNotesScreen";

function RmoNotes() {
  return (
    <ClinicalNotesScreen
      screenTitle="RMO Notes"
      notesLabel="RMO Notes"
      staffLabel="RMO Name"
      isNursingNotes={false}
      useLiveApi
    />
  );
}

export default RmoNotes;
